<template>
  <div style="position: relative;height:880px;">
    <div v-if="finish">
      <iframe  id="show-iframe" width="100%" height="880px" src="/static/pdfjs/web/viewer.html"></iframe>
      <!--底部按钮-->
      <div style="position: absolute; top: 97%; width: 100%">
        <Row >
          <div>
            <Col span="8" offset="11"><Button type="primary" size="large" @click="closeReport()">{{$t('diagnosis.closeReport')}}</Button></Col>
          </div>
        </Row>
      </div>
    </div>
    <div v-else>
      <div style="margin-left: 50%;margin-top: 40%">
        <Spin size="large"></Spin>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseDiagnosisInfo',
  data () {
    return {
      reportPdfUrl: '', // pdf报告路径
      isShowDiagnosis: false, // // 是否显示报告
      finish: false, // 是否加载完成
      readonly: false, // 只读
      report: '', // 报告的base64
      pathologyId: '' // 病理号
    }
  },
  props: {
    caseId: {
      type: String,
      default: null
    },
    showOnly: {
      type: String,
      default: '1'
    }
  },
  methods: {
    // 关闭报告模态框
    closeReport () {
      this.$emit('getIsShowDiagnosis', this.isShowDiagnosis)
    },
    // 获取报告
    getCaseReport () {
      let params = new URLSearchParams()
      params.append('CASE_ID', this.caseId.toString())
      let reportUrl = 'GET_CASE_REPORT_URL'
      // 查看病例报告
      if (this.showOnly === '1') {
        reportUrl = 'SHOW_CASE_REPORT_URL'
      }
      this.$http.post(this.$vue.getData(reportUrl), params).then(suc => {
        if (suc.data.result === '1') {
          this.pathologyId = suc.data.data.pathologyId
          sessionStorage.setItem('pathologyId', this.pathologyId)
          sessionStorage.setItem('caseId', this.caseId)
          // this.reportPdfUrl = suc.data.data.reportPdfUrl
          // 完成后关闭加载动画
          if (this.showOnly === '1') {
            setTimeout(() => {
              this.finish = true
            }, 1000)
          } else {
            this.finish = true
          }
        } else {
          setTimeout(() => {
            this.$emit('getIsShowDiagnosis', this.isShowDiagnosis)
            if (this.showOnly === '1') {
              this.$Notice.warning({
                title: this.$t('diagnosis.errorReminder'),
                desc: this.$t('diagnosis.reportDoesNotExistTip')
              })
            } else {
              this.$Notice.warning({
                title: this.$t('caseList.messageNotification'),
                desc: this.$t('diagnosis.failedToEditReportTip')
              })
            }
          }, 1000)
        }
      })
    },
    // 下载报告
    downloadIamge () {
      let params = new URLSearchParams()
      params.append('reportPdfUrl', this.reportPdfUrl)
      this.$http.post(this.$vue.getData('UPLOAD_REPORT_URL'), params, {responseType: 'blob'}).then(suc => {
        let url = window.URL.createObjectURL(new Blob([suc.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        // download 属性定义了下载链接的地址而不是跳转路径
        link.setAttribute('download', this.pathologyId + '.pdf')
        document.body.appendChild(link)
        link.click()
        this.$emit('getIsShowDiagnosis', this.isShowDiagnosis)
      })
    }
  },
  beforeMount  () {
    this.$vue = this
    this.getCaseReport()
  }

}
</script>

<style scoped>
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
</style>



// WEBPACK FOOTER //
// src/components/base/diagnosis/CaseDiagnosisInfo.vue